const { onlyAlphaNumeric, SPACE } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyAlphaNumeric(zipCode);
  if (zipCode.length <= 2) {
    return zip;
  }
  return `${zip.slice(0, 2).toUpperCase()}-${zip.slice(2, 7)}`;
};

exports.countryDefinition = {
  country: 'Lithuania',
  code: 'LT',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Locality', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^LV-[0-9]{5}$/),
      error: 'Must be LT + 5 numbers, LT-04340'
    }
  ]
};
